import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const crowdin = defineConnector({
  identifier: "crowdin",
  name: "Crowdin",
  tagLine: "Localization management platform",
  logo,
  protocol: "http",
  tags: ["engineering", "productivity"],
  defaultUrlPattern: () => "https://api\\.crowdin\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit [Crowdin Account Settings > API](https://crowdin.com/settings#api-key) and create a new personal access token.",
        },
      ],
    },
    {
      title: "Copy and paste the token into the field below",
      items: [
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.crowdin.com/api/v2/user",
  },
});
